import { PropsWithChildren, ReactNode } from 'react';

import { Typography, Stack, tokens } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

type Props = PropsWithChildren<{ heading: ReactNode } & StackProps>;

export const WidgetContainer = ({
  children,
  heading,
  ...stackProps
}: Props) => {
  return (
    <Stack direction="column" gap="8px" {...stackProps}>
      <Typography variant="A1" color={tokens.theme.fg.structural.secondary}>
        {heading}
      </Typography>
      {children}
    </Stack>
  );
};
